module.exports = __webpack_public_path__ + "media/base/download-b81775f3.svg";